import React from 'react';
import { ChevronLeft, Menu } from 'lucide-react';
interface HeaderProps {
  onBack: () => void;
  showBack: boolean;
}
export function Header({
  onBack,
  showBack
}: HeaderProps) {
  return <header className="flex items-center justify-between px-6 py-2 w-full max-w-4xl mx-auto text-[#121212] relative z-10" data-id="element-50">
      <div className="w-10 h-10 flex items-center justify-center" data-id="element-51">
        {showBack && <button onClick={onBack} className="p-2 hover:bg-[#B45092]/20 rounded-full transition-colors" aria-label="Volver" data-id="element-52">
            <ChevronLeft className="w-6 h-6" data-id="element-53" />
          </button>}
      </div>

      <div className="flex flex-col items-center" data-id="element-54">
        <img src="https://cdn.magicpatterns.com/uploads/hqGNXtwry4xQkqUYCrsm4f/psiquicos-logo-wizard.png" alt="Psíquicos" className="h-6 w-auto" data-id="element-55" />
      </div>

      <div className="w-10 h-10 flex items-center justify-center" data-id="element-56">
        <button className="p-2 hover:bg-[#B45092]/20 rounded-full transition-colors" aria-label="Menú" data-id="element-57"></button>
      </div>
    </header>;
}